import { CheckCircle2, Phone } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PHONE_DISPLAY, PHONE_HREF } from "@/lib/landingLinks";

/** What a sender sees once the brief is in. The reference is the useful part. */
export const ScopingSuccess = ({ reference, acknowledged }) => (
  <div data-testid="scoping-success" className="tt-card p-6 sm:p-8">
    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[color:var(--tt-teal-mist)] text-primary">
      <CheckCircle2 className="h-5 w-5" aria-hidden="true" />
    </span>

    <h3 className="mt-5 text-[22px] font-bold leading-tight text-foreground sm:text-[26px]">
      Thank you — we have your brief
    </h3>
    <p className="mt-3 max-w-[56ch] text-sm leading-relaxed text-muted-foreground sm:text-[15px]">
      Your reference is{" "}
      <span
        data-testid="scoping-success-reference"
        className="font-amount font-semibold text-foreground"
      >
        {reference}
      </span>
      . We&apos;ll review what you&apos;ve told us, come back to you on anything that needs
      filling in, and then recommend a team structure and one monthly fee.
    </p>

    {acknowledged === false ? (
      <p className="mt-4 text-[13px] leading-relaxed text-muted-foreground">
        Keep this reference handy — please quote it when we speak.
      </p>
    ) : null}

    <Button
      asChild
      variant="outline"
      data-testid="scoping-success-call"
      className="mt-6 h-12 min-h-[44px] bg-white px-5 text-[15px] font-semibold"
    >
      <a href={PHONE_HREF}>
        <Phone className="mr-2 h-4 w-4" aria-hidden="true" />
        Rather talk now? {PHONE_DISPLAY}
      </a>
    </Button>
  </div>
);
